<div class="modal-header">
    <h4 class="modal-title">Dealer Entry</h4>
</div>
<div class="modal-body" (keyup.esc)="close()" (keyup.enter)="save()">
    <dx-form [formData]="dealer" [validationGroup]="validationGroup">
        <dxi-item dataField="companyName" [label]="{ text: 'Company' }">
            <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="portalEmail" [label]="{ text: 'Email' }">
            <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
        </dxi-item>
    </dx-form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="save(true)">Save and Send</button>
    <button type="button" class="btn btn-success" (click)="save()">Save</button>
    <button type="button" class="btn btn-light" (click)="close()">Cancel</button>
</div>
